import React from 'react';

import { businessTemplates } from '../../data/rubros';
import './SelectorDeRubro.css';

/**
 * El rubro del negocio, editable desde el panel.
 *
 * Hasta ahora el rubro se elegía una sola vez, en el primer paso del
 * onboarding, y no había ninguna pantalla para cambiarlo: quien se equivocaba
 * —o el negocio que con el tiempo pasó de peluquería a centro de estética—
 * quedaba con esa etiqueta para siempre en su página pública.
 *
 * Muestra los siete presets con el actual marcado. Son los mismos de
 * data/rubros.js, que es la fuente única: agregar un rubro ahí lo hace aparecer
 * acá, en el onboarding y en la landing a la vez.
 *
 * Lo que el cambio hace y lo que NO hace está escrito en la pantalla a
 * propósito. Cambiar el rubro NO vuelve a cargar servicios, espacios ni roles:
 * las listas de `suggested*` son valores iniciales del onboarding, y pisar con
 * ellas lo que el negocio ya tiene cargado sería destruir trabajo por haber
 * tocado una etiqueta. Sin decirlo, la expectativa razonable es la contraria.
 */
export default function SelectorDeRubro({ valor, onChange }) {
  return (
    <div className="selector-rubro">
      <p className="selector-rubro__ayuda">
        Es la etiqueta que ven tus clientes al lado del nombre de tu negocio, y
        la que decide los ejemplos que te sugiere el panel. Cambiarlo no toca
        tus servicios, espacios ni personal: eso queda como lo tenés.
      </p>

      <div className="selector-rubro__grilla" role="radiogroup" aria-label="Rubro del negocio">
        {businessTemplates.map((rubro) => {
          const elegido = valor === rubro.id;

          return (
            <button
              key={rubro.id}
              type="button"
              role="radio"
              aria-checked={elegido}
              className={`selector-rubro__opcion${elegido ? ' es-elegido' : ''}`}
              onClick={() => onChange(rubro.id)}
            >
              <span className="selector-rubro__icono" aria-hidden="true">
                {rubro.icon}
              </span>
              <span className="selector-rubro__texto">
                <span className="selector-rubro__nombre">{rubro.name}</span>
                <span className="selector-rubro__descripcion">{rubro.description}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
